export interface RunInfo {
  readonly runName: string;
  readonly runDirectory: string;
  readonly timestamp: string;
  readonly sequentialNumber: number;
}